import { usePracticeAccess } from '@hb/react'
import { TELEPHONE_CONTACTS, TelephoneContact } from '@hb/shared'
import { collectionGroup, orderBy, query, Query, where } from 'firebase/firestore'
import { useMemo } from 'react'
import { db } from '../../../backend/db'
import { useQuery } from '../useQuery'

export const usePracticeContactsForReview = () => {
  const { selectedPracticeId } = usePracticeAccess()
  const ref = useMemo(() => {
    if (!selectedPracticeId) return null
    return query(
      collectionGroup(db, TELEPHONE_CONTACTS) as Query<TelephoneContact>,
      where('practiceId', '==', selectedPracticeId),
      where('billingStatus', '==', 'review-for-billing'),
      orderBy('date', 'desc'),
    )
  }, [selectedPracticeId])
  return useQuery<TelephoneContact>(ref)
}
